export const DEACTIVATE_WORKSPACE_WORKFLOW_SKILL_NAME =
  "deactivate_workspace_workflow_skill";

export const DEACTIVATE_WORKSPACE_WORKFLOW_SKILL_DESC = `Detaches an active workspace skill from the current chat thread.

Inputs:
- workflowSkillId (optional): Skill ID when already known.
- skillTitle (optional): Skill title to match among the current thread's active skills.

Use this when the user wants to stop applying a skill on the current thread. This action runs through confirmation.`;
